import { ResolveFn } from '@angular/router';
import {inject} from '@angular/core';
import {RenderStrategy} from '../../enums/render-strategy';
import {GoldenTipService} from '../golden-tip.service';
import {Subscription} from 'rxjs';

export const goldenTipIndexResolver: ResolveFn<Promise<void | Subscription>> = () => {
  return inject(GoldenTipService).resolveIndex(RenderStrategy.PREFER_SERVER);
};
